import $ from 'jquery';
import SelectService from '../service/SelectService';
import CatalogService from '../service/CatalogService';
import StoreService from '../service/StoreService';
import HistoryManager from '../util/HistoryManager';


/*
    FILTER UPDATES LOGIC
*/
const selectSubcategoryOptionsUpdate = (value) => {
    const { dom } = SelectService.getControl('catalog-subcategory');
    if (value === false) {
        dom.options.addClass('control-select-option--hidden');
    } else {
        dom.options.addClass('control-select-option--hidden')
            .filter(`.control-select-option--section-${value}`)
            .removeClass('control-select-option--hidden');
    }
};

selectSubcategoryOptionsUpdate(SelectService.getValue('catalog-category'));

SelectService.onChange('catalog-category', (value) => {
    selectSubcategoryOptionsUpdate(value);
    SelectService.setValue('catalog-subcategory', false);
});

SelectService.onQuery('catalog-category', (name, value) => {
    if (value === false) {
        HistoryManager.push(`/catalog/${window.location.search}`);
    } else {
        HistoryManager.push(`/catalog/${value}/${window.location.search}`);
    }
});

SelectService.onChange('catalog-sort', () => {
    $('.filter--catalog').submit();
});

/*
    CATALOG UPDATES
*/
const getFilterParameters = () => {
    const parameters = HistoryManager.current().getParameters();
    const category = SelectService.getValue('catalog-category');
    if (category) {
        parameters.category = category;
    }
    return parameters;
};

$('.filter--catalog').submit(function (event) {
    event.preventDefault();
    const parameters = getFilterParameters();

    $('.catalog-section-more').hide();
    CatalogService.getItems(parameters)
        .then((response) => {
            if (response.nextpage) {
                $('.catalog-section-more').show();
            }
            CatalogService.renderItems(response.items);
        });
});

if ($('.catalog-section').length) {
    StoreService.onChange(() => {
        const parameters = getFilterParameters();

        $('.catalog-section-more').hide();
        CatalogService.getItems(parameters)
            .then((response) => {
                if (response.nextpage) {
                    $('.catalog-section-more').show();
                }
                CatalogService.renderItems(response.items);
            });
    });
}

let page = 1;
$('.catalog-section-more').click(function () {
    page += 1;

    const parameters = getFilterParameters();
    parameters.page = page;

    CatalogService.getItems(parameters)
        .then((response) => {
            if (response.nextpage) {
                $('.catalog-section-more').show();
            } else {
                $('.catalog-section-more').hide();
            }
            CatalogService.renderItems(response.items, true);
        });
});
